
import React, { useState } from 'react'

import TextInput from './TextInput';

import { LuEye, LuEyeOff } from "react-icons/lu";


export default function PasswordInput({ styled, value, onChange, ...otherProps }) {

    const [shown, setShown] = useState(false);

    return (
        <TextInput 
            type={shown ? "text" : "password"} styled={styled}
            value={value} onChange={onChange}
            {...otherProps}
            suffix={
                <div className="cursor-pointer text-[--gray-11]" onClick={_ => setShown(prev => !prev)}>
                    { shown ? <LuEyeOff /> : <LuEye /> }
                </div>
            }
        />
    )
}
